var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Caller } from '@readium/glue-rpc';
import { EventHandlingMessage } from './interface';
export class EventHandling extends Caller {
    addEventListener(eventType, listener, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.call(EventHandlingMessage.AddEventListener, [eventType, options], (payload) => {
                listener(payload[0]);
            });
        });
    }
    removeEventListener(listenerID) {
        this.call(EventHandlingMessage.RemoveEventListener, [listenerID]);
    }
}
//# sourceMappingURL=caller.js.map